module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	'use strict';

	var Promise = fox.RSVP.Promise;
	var storage = new fox.LocalStorageObjectService({
		lsLabel: '_smas_',
		cleanCheckInterval: 1000 * 60 * 60 * 24 * 15
	});

	var storageValue = fox.objectGet(storage.getItem('tips'), 'value');

	var result = fox.isUndefined(storageValue) ? null : storageValue;

	function checker (menuItem, key, _this) {
		var api = _this.getApi('checkTips', {
			method: 'tips.getTipsCount',
			cacheChannel: 'site',
			sendTimezone: true
		});
		
		return result === null && new Promise(function (resolve) {
			return api.psend().then(function (resp) {
				result = fox.objectGet(resp, 'params.answer.response') > 0;

				if (fox._isNewfe) api.destroy();

				storage.setItem('tips', {value: result});

				return resolve(result);
			}).catch(function () {resolve(false);});
		}.bind(_this)) || result;
	}

	fox.registerOptions('~.Menu_Main', {
		'pattern.tipsChecker.checkers.hasTipOptions': {
			callback: checker,
			async: true
		}
	}, 1, {});
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/menu/checkers/tips.js
// module id = 866
// module chunks = 4